import {NgModule} from '@angular/core';
import {DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';
import {MatIconModule, MatIconRegistry} from '@angular/material/icon';

@NgModule({
  imports: [
    MatIconModule
  ],
  exports: [
    MatIconModule
  ]
})
export class IconsModule {

  private path = './assets/svg/outlined/';
  private filledPath = './assets/svg/filled/';
  private iconsPath = 'assets/icons/';
  private imagesPath = 'assets/images/';

  constructor(
    private domSanitizer: DomSanitizer,
    public matIconRegistry: MatIconRegistry) {
    this.matIconRegistry
      .addSvgIcon('menu', this.setPath('menu.svg'))
      .addSvgIcon('search', this.setPath('search.svg'))
      .addSvgIcon('notifications', this.setPath('notifications.svg'))
      .addSvgIcon('account_circle', this.setPath('account_circle.svg'))
      .addSvgIcon('account_circle_filled', this.setFilledPath('account_circle.svg'))
      .addSvgIcon('home', this.setPath('home.svg'))
      .addSvgIcon('inbox', this.setPath('inbox.svg'))
      .addSvgIcon('control_camera', this.setPath('control_camera.svg'))
      .addSvgIcon('work_outline', this.setPath('work_outline.svg'))
      .addSvgIcon('expand_more', this.setPath('expand_more.svg'))
      .addSvgIcon('expand_less', this.setPath('expand_less.svg'))
      .addSvgIcon('chevron_left', this.setPath('chevron_left.svg'))
      .addSvgIcon('chevron_right', this.setPath('chevron_right.svg'))
      .addSvgIcon('add', this.setPath('add.svg'))
      .addSvgIcon('layers', this.setPath('layers.svg'))
      .addSvgIcon('chat_bubble_outline', this.setPath('chat_bubble_outline.svg'))
      .addSvgIcon('info', this.setPath('info.svg'))
      .addSvgIcon('arrow_back', this.setPath('arrow_back.svg'))
      .addSvgIcon('arrow_forward', this.setPath('arrow_forward.svg'))
      .addSvgIcon('arrow_upward', this.setPath('arrow_upward.svg'))
      .addSvgIcon('arrow_downward', this.setPath('arrow_downward.svg'))
      .addSvgIcon('close', this.setPath('close.svg'))
      .addSvgIcon('cancel', this.setPath('cancel.svg'))
      .addSvgIcon('cancel_filled', this.setFilledPath('cancel.svg'))
      .addSvgIcon('play_circle_outline', this.setPath('play_circle_outline.svg'))
      .addSvgIcon('stop', this.setPath('stop.svg'))
      .addSvgIcon('play_arrow', this.setPath('play_arrow.svg'))
      .addSvgIcon('radio_button_unchecked', this.setPath('radio_button_unchecked.svg'))
      .addSvgIcon('radio_button_checked', this.setPath('radio_button_checked.svg'))
      .addSvgIcon('language', this.setPath('language.svg'))
      .addSvgIcon('grid_view', this.setPath('grid_view.svg'))
      .addSvgIcon('settings', this.setPath('settings.svg'))
      .addSvgIcon('settings_filled', this.setFilledPath('settings.svg'))
      .addSvgIcon('remove', this.setPath('remove.svg'))
      .addSvgIcon('more_vert', this.setPath('more_vert.svg'))
      .addSvgIcon('person', this.setPath('person.svg'))
      .addSvgIcon('file_download', this.setPath('file_download.svg'))
      .addSvgIcon('schedule', this.setPath('schedule.svg'))
      .addSvgIcon('check_box_outline_blank', this.setPath('check_box_outline_blank.svg'))
      // .addSvgIcon('check_box', this.setPath('check_box.svg'))
      .addSvgIcon('check_box', this.setFilledPath('check_box.svg'))
      .addSvgIcon('swap_vert', this.setPath('swap_vert.svg'))
      .addSvgIcon('delete', this.setPath('delete.svg'))
      .addSvgIcon('edit', this.setPath('edit.svg'))
      .addSvgIcon('remove_red_eye', this.setPath('remove_red_eye.svg'))
      .addSvgIcon('visibility', this.setPath('visibility.svg'))
      .addSvgIcon('visibility_off', this.setPath('visibility_off.svg'))
      .addSvgIcon('insert_link', this.setPath('insert_link.svg'))
      .addSvgIcon('place', this.setPath('place.svg'))
      .addSvgIcon('toggle_on', this.setPath('toggle_on.svg'))
      .addSvgIcon('toggle_off', this.setPath('toggle_off.svg'))
      .addSvgIcon('send', this.setPath('send.svg'))
      .addSvgIcon('last_page', this.setPath('last_page.svg'))
      .addSvgIcon('first_page', this.setPath('first_page.svg'))
      .addSvgIcon('open_in_new', this.setPath('open_in_new.svg'))
      .addSvgIcon('light_mode', this.setPath('light_mode.svg'))
      .addSvgIcon('desktop_windows', this.setPath('desktop_windows.svg'))
      .addSvgIcon('show_chart', this.setPath('show_chart.svg'))
      .addSvgIcon('equalizer', this.setPath('equalizer.svg'))
      .addSvgIcon('format_list_bulleted', this.setPath('format_list_bulleted.svg'))
      .addSvgIcon('description', this.setPath('description.svg'))
      .addSvgIcon('grid_view', this.setPath('grid_view.svg'))
      .addSvgIcon('change_circle', this.setPath('change_circle.svg'))
      .addSvgIcon('calendar_today', this.setPath('calendar_today.svg'))
      .addSvgIcon('refresh', this.setPath('refresh.svg'))
      .addSvgIcon('first_page', this.setPath('first_page.svg'))
      .addSvgIcon('last_page', this.setPath('last_page.svg'))
      .addSvgIcon('filter_alt', this.setPath('filter_alt.svg'))
      .addSvgIcon('import_contacts', this.setPath('import_contacts.svg'))
      .addSvgIcon('logout', this.setPath('logout.svg'))
      .addSvgIcon('lock', this.setPath('lock.svg'))
      .addSvgIcon('restart_alt', this.setPath('restart_alt.svg'))
      .addSvgIcon('shield', this.setPath('shield.svg'))
      .addSvgIcon('token', this.setPath('token.svg'))
      .addSvgIcon('error_outline', this.setPath('error_outline.svg'))
      .addSvgIcon('done', this.setPath('done.svg'))
      .addSvgIcon('import_export', this.setPath('import_export.svg'))
      .addSvgIcon('warning_amber', this.setPath('warning_amber.svg'))
      .addSvgIcon('warning', this.setPath('warning.svg'))
      .addSvgIcon('pages', this.setPath('pages.svg'))
      .addSvgIcon('newRelease', this.setPath('new_releases.svg'))
      .addSvgIcon('buildCircle', this.setPath('build_circle.svg'))
      .addSvgIcon('note_alt', this.setPath('note_alt.svg'))
      .addSvgIcon('person', this.setPath('person.svg'))
      .addSvgIcon('person_add', this.setPath('person_add.svg'))
      .addSvgIcon('power_settings_new', this.setPath('power_settings_new.svg'))
      .addSvgIcon('settings', this.setPath('settings.svg'))
      .addSvgIcon('account_box', this.setPath('account_box.svg'))
      .addSvgIcon('grading', this.setPath('grading.svg'))
      .addSvgIcon('accessibility', this.setPath('accessibility.svg'))
      .addSvgIcon('grading', this.setPath('grading.svg'))
      .addSvgIcon('integration_instructions', this.setPath('integration_instructions.svg'))
      .addSvgIcon('rocket', this.setPath('rocket.svg'))
      .addSvgIcon('diamond', this.setPath('diamond.svg'))
      .addSvgIcon('emergency', this.setPath('emergency.svg'))
      .addSvgIcon('turned_in_not', this.setPath('turned_in_not.svg'))
      .addSvgIcon('tips_and_updates', this.setPath('tips_and_updates.svg'))
      .addSvgIcon('incomplete_circle', this.setPath('incomplete_circle.svg'))
      .addSvgIcon('content_copy', this.setPath('content_copy.svg'))
      .addSvgIcon('folder_copy', this.setPath('folder_copy.svg'))
      .addSvgIcon('menu_open', this.setPath('menu_open.svg'))
      .addSvgIcon('account_balance', this.setPath('account_balance.svg'))
      .addSvgIcon('no_accounts', this.setPath('no_accounts.svg'))
      .addSvgIcon('next_week', this.setPath('next_week.svg'))
      .addSvgIcon('task_alt', this.setPath('task_alt.svg'))
      .addSvgIcon('sync', this.setPath('sync.svg'))
      .addSvgIcon('arrow_drop_down', this.setPath('arrow_drop_down.svg'))
      .addSvgIcon('expand_circle_down', this.setPath('expand_circle_down.svg'))
      .addSvgIcon('table_chart', this.setPath('table_chart.svg'))
      .addSvgIcon('cloud', this.setPath('cloud.svg'))
      .addSvgIcon('cloud_sync', this.setPath('cloud_sync.svg'))
      .addSvgIcon('inventory_2', this.setPath('inventory_2.svg'))
      .addSvgIcon('batch_prediction', this.setPath('batch_prediction.svg'))
      .addSvgIcon('article', this.setPath('article.svg'))
      .addSvgIcon('view_kanban', this.setPath('view_kanban.svg'))
      .addSvgIcon('arrow_right_alt', this.setPath('arrow_right_alt.svg'))
      .addSvgIcon('library_add_check', this.setPath('library_add_check.svg'))
      .addSvgIcon('checklist', this.setPath('checklist.svg'))
      .addSvgIcon('bookmark_border', this.setPath('bookmark_border.svg'))
      .addSvgIcon('do_not_disturb_alt', this.setPath('do_not_disturb_alt.svg'))
      .addSvgIcon('outbound', this.setPath('outbound.svg'))
      .addSvgIcon('check', this.setPath('check.svg'))
      .addSvgIcon('link', this.setPath('link.svg'))
      .addSvgIcon('sync_alt', this.setPath('sync_alt.svg'))
      .addSvgIcon('help_outline', this.setPath('help_outline.svg'))
      .addSvgIcon('bookmark', this.setPath('bookmark.svg'))
      .addSvgIcon('circle', this.setPath('circle.svg'))
      .addSvgIcon('check_circle', this.setPath('check_circle.svg'))
      .addSvgIcon('check_circle_filled', this.setFilledPath('check_circle.svg'))
      .addSvgIcon('highlight_off', this.setPath('highlight_off.svg'))
      .addSvgIcon('bar_chart', this.setPath('bar_chart.svg'))
      .addSvgIcon('list', this.setPath('list.svg'))
      .addSvgIcon('campaign', this.setPath('campaign.svg'))
      .addSvgIcon('location_on', this.setPath('location_on.svg'))
      .addSvgIcon('cameraswitch', this.setPath('cameraswitch.svg'))
      .addSvgIcon('error', this.setPath('error.svg'))
      .addSvgIcon('priority_high', this.setPath('priority_high.svg'))
      .addSvgIcon('settings_applications', this.setPath('settings_applications.svg'))
      .addSvgIcon('key', this.setPath('key.svg'))
      .addSvgIcon('timer', this.setPath('timer.svg'))
      .addSvgIcon('stop_circle', this.setPath('stop_circle.svg'))
      .addSvgIcon('upload_file', this.setPath('upload_file.svg'))
      .addSvgIcon('chat', this.setPath('chat.svg'))
      .addSvgIcon('work_history', this.setPath('work_history.svg'))
      .addSvgIcon('do_not_disturb_on', this.setPath('do_not_disturb_on.svg'))
      .addSvgIcon('report_problem', this.setPath('report_problem.svg'))
      .addSvgIcon('pending_actions', this.setPath('pending_actions.svg'))
      .addSvgIcon('upload', this.setPath('upload.svg'))
      .addSvgIcon('settings_suggest', this.setPath('settings_suggest.svg'))
      .addSvgIcon('delete_forever', this.setPath('delete_forever.svg'))
      .addSvgIcon('extension', this.setPath('extension.svg'))
      .addSvgIcon('play_circle', this.setPath('play_circle.svg'))
      .addSvgIcon('hourglass_empty', this.setPath('hourglass_empty.svg'))
      .addSvgIcon('computer', this.setPath('computer.svg'))
      .addSvgIcon('sensors', this.setPath('sensors.svg'))
      .addSvgIcon('block', this.setPath('block.svg'))
      .addSvgIcon('manage_history', this.setPath('manage_history.svg'))
      .addSvgIcon('more_time', this.setPath('more_time.svg'))
      .addSvgIcon('description', this.setPath('description.svg'))
      .addSvgIcon('sort_by_alpha', this.setPath('sort_by_alpha.svg'))
      .addSvgIcon('drag_indicator', this.setPath('drag_indicator.svg'))
      .addSvgIcon('folder_zip', this.setPath('folder_zip.svg'))
      .addSvgIcon('content_paste', this.setPath('content_paste.svg'))
      .addSvgIcon('overview', this.setPath('overview.svg'))
      .addSvgIcon('assignment', this.setPath('assignment.svg'))
      .addSvgIcon('analytics', this.setPath('analytics.svg'))
      .addSvgIcon('fact_check', this.setPath('fact_check.svg'))
      .addSvgIcon('monitor', this.setPath('monitor.svg'))
      .addSvgIcon('summarize', this.setPath('summarize.svg'))
      .addSvgIcon('security', this.setPath('security.svg'))
      .addSvgIcon('dns', this.setPath('dns.svg'))
      .addSvgIcon('find_in_page', this.setPath('find_in_page.svg'))
      .addSvgIcon('not_started', this.setPath('not_started.svg'))
      .addSvgIcon('view_timeline', this.setPath('view_timeline.svg'))
      .addSvgIcon('system_update_alt', this.setPath('system_update_alt.svg'))
      .addSvgIcon('subtitles', this.setPath('subtitles.svg'))
      .addSvgIcon('book', this.setPath('book.svg'))
      .addSvgIcon('web_stories', this.setPath('web_stories.svg'))
      .addSvgIcon('work_off', this.setPath('work_off.svg'))
      .addSvgIcon('keyboard_arrow_down', this.setPath('keyboard_arrow_down.svg'))
      .addSvgIcon('keyboard_arrow_up', this.setPath('keyboard_arrow_up.svg'))
      .addSvgIcon('chat_info', this.setIconsPath('chat_info.svg'))
      .addSvgIcon('rule_settings', this.setIconsPath('rule_settings.svg'))
      .addSvgIcon('double_right_arrow', this.setImagesPath('double_right_arrow.svg'))
      .addSvgIcon('circle_tick', this.setImagesPath('circle_tick.svg'))
      .addSvgIcon('circle_dot', this.setImagesPath('circle_dot.svg'))
      .addSvgIcon('document_scanner', this.setPath('document_scanner.svg'))
      .addSvgIcon('settings_backup_restore', this.setImagesPath('settings_backup_restore.svg'))
      .addSvgIcon('message_icon', this.setIconsPath('message_icon.svg'))
      .addSvgIcon('run_circle', this.setPath('run_circle.svg'))
      .addSvgIcon('image', this.setPath('image.svg'))
      .addSvgIcon('motion_photos_on', this.setPath('motion_photos_on.svg'))
      .addSvgIcon('back_hand', this.setPath('back_hand.svg'))
      .addSvgIcon('clock_loader_20', this.setIconsPath('clock_loader_20.svg'))
      .addSvgIcon('menu_book', this.setPath('menu_book.svg'))
      .addSvgIcon('tag', this.setPath('tag.svg'))
      .addSvgIcon('apps', this.setPath('apps.svg'))
      .addSvgIcon('layers_filled', this.setImagesPath('layers_filled.svg'))
      .addSvgIcon('release_notes', this.setImagesPath('release_notes.svg'))
      .addSvgIcon('error_filled', this.setFilledPath('error.svg'))
      .addSvgIcon('share_eta', this.setIconsPath('share_eta.svg'))
      .addSvgIcon('warning', this.setIconsPath('warning.svg'))
      .addSvgIcon('Ellipse', this.setIconsPath('Ellipse.svg'))
      .addSvgIcon('encrypted', this.setIconsPath('encrypted.svg'))
      .addSvgIcon('account_balance_wallet', this.setPath('account_balance_wallet.svg'))
  }

  private setPath(icon: string): SafeResourceUrl {
    return this.domSanitizer.bypassSecurityTrustResourceUrl(this.path + icon);
  }

  private setFilledPath(icon: string): SafeResourceUrl {
    return this.domSanitizer.bypassSecurityTrustResourceUrl(this.filledPath + icon);
  }

  private setIconsPath(icon: string): SafeResourceUrl {
    return this.domSanitizer.bypassSecurityTrustResourceUrl(this.iconsPath + icon);
  }

  private setImagesPath(icon: string): SafeResourceUrl {
    return this.domSanitizer.bypassSecurityTrustResourceUrl(this.imagesPath + icon);
  }
}
